import {gql} from '@apollo/client';

export const GET_SORTER_PLAN_WORK_WAREHOUSE_OPTIONS = gql`
    query GetSorterPlanWorkWarehouseOptions($warehouseId: Long!) {
        getSorterPlanWorkWarehouseOptions(warehouseId: $warehouseId) {
            id
            name
        }
    }
`;

export interface SorterPlanWorkWarehouseOption {
    id: number;
    name?: string;
}

export interface GetSorterPlanWorkWarehouseOptionsData {
    getSorterPlanWorkWarehouseOptions: SorterPlanWorkWarehouseOption[];
}
